/**************************************************
 * Nombre:       BarraCell
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {ButtonBase, Drawer, Grid, IconButton, Typography} from "@mui/material";
import logo from '../../Recursos/logo_oscuro.png'
import {Close, Menu} from '@mui/icons-material'
import {useState} from "react";
import {REDES, SECCIONES} from "../../Constantes";
import {useNavigate} from "react-router";
import {irUrl} from "../../Utilidades/irUrl";
import {theme} from "../../Tema";
import {useIrRuta} from "../../Utilidades/useIrRuta";

const BarraCell = ({negro}) => {
    const navigate = useNavigate()
    const {ir} = useIrRuta()
    const [open, setOpen] = useState(false)


    return (
        <Grid
            container
            justifyContent={'space-between'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: negro ? '#000' : '#00000000', px: 3, py: 3}}
        >

            <img
                onClick={() => navigate('/Home')}
                src={logo} width={60} height={'auto'} style={{marginTop: -5}}/>

            <IconButton
                onClick={() => setOpen(true)}
                sx={{backgroundColor: theme.palette.primary.main, mt: -4}}
            >
                <Menu sx={{fill: '#fff'}}/>
            </IconButton>

            <Drawer open={open} onClose={() => setOpen(false)}
                    anchor={'right'}
            >

                <Grid container size={{xs: 12, ms: 12, md: 12}}>
                    <IconButton
                        onClick={() => setOpen(false)}
                    >
                        <Close sx={{fill: '#fff'}}/>
                    </IconButton>
                </Grid>

                <Grid container size={{xs: 12, ms: 12, md: 12}}
                      sx={{width: 300, p: 2, marginTop: 2, justifyContent: 'center'}}>


                    {SECCIONES.map((item, index) => (
                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'center', marginTop: 2}}>
                            <ButtonBase
                                onClick={() => {
                                    setOpen(false)
                                    setTimeout(() => {
                                        ir(item)
                                    }, 500)
                                }}

                            >
                                <Typography
                                    sx={{
                                        color: '#fff',
                                        fontSize: 20,
                                        fontWeight: 600,
                                        textAlign: 'center'
                                    }}>{item}</Typography>
                            </ButtonBase>
                        </Grid>
                    ))}


                    <Grid container size={{xs: 12, ms: 12, md: 12}}
                          sx={{bottom: '2%', justifyContent: 'center', marginTop: 50}}>
                        <img src={logo} width={70} height={'auto'}/>
                    </Grid>

                    <Grid container size={{xs: 10, ms: 12, md: 12}}
                          sx={{bottom: '2%', justifyContent: 'center', marginTop: 2}}>
                        {REDES.map((item, index) => {
                            return (
                                <Grid container size={{xs: 3, ms: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                    <IconButton
                                        onClick={() => irUrl(item.url)}
                                    >
                                        <img src={item.imgColor} width={32} height={'auto'}/>
                                    </IconButton>
                                </Grid>
                            )
                        })}
                    </Grid>


                </Grid>

            </Drawer>

        </Grid>
    )

}
export default BarraCell